import SvgIcon from '@mui/material/SvgIcon';
import Tooltip from '@portalterreno/react-ui-core/Tooltip';
import InfoIcon from '@portalterreno/react-ui-icons/InfoIcon';
import Image from 'next/image';
import React from 'react';

import DescriptionWrapper from './DescriptionWrapper';
import IconWrapper from './IconWrapper';
import InformationWrapper from './InformationWrapper';
import StyledBodyTypography from './StyledBodyTypography';
import StyledEpigraphTypography from './StyledEpigraphTypography';
import StyledTitleTypography from './StyledTitleTypography';
import Wrapper from './Wrapper';

export type BadgeProps = React.PropsWithChildren<{
  body: React.ReactNode;
  epigraph?: React.ReactNode;
  icon?: typeof SvgIcon;
  image?: string;
  title: string;
  description?: string;
}>;

const Badge: React.FC<BadgeProps> = ({
  body,
  epigraph,
  icon: Icon,
  title,
  image,
  description
}) => {
  return (
    <Wrapper>
      {Icon && (
        <IconWrapper>
          <Icon fontSize='inherit' />
        </IconWrapper>
      )}
      {image && (
        <Image
          src={image}
          alt={title}
          height={25}
          width={25}
          quality={100}
        />
      )}
      <InformationWrapper>
        <StyledTitleTypography
          variant='text'
          as='p'
          weight='regular'
          color='blackCoral'
        >
          {title}
        </StyledTitleTypography>
        <StyledBodyTypography
          variant='body2'
          weight='medium'
          color='midnightBlue'
        >
          {body}
        </StyledBodyTypography>

        {epigraph && (
          <StyledEpigraphTypography
            variant='body1'
            weight='regular'
            color='blackCoral'
          >
            {epigraph}
          </StyledEpigraphTypography>
        )}
      </InformationWrapper>

      {description && (
        <DescriptionWrapper>
          <Tooltip
            label={description}
            placement='top'
          >
            <InfoIcon color='inherit' />
          </Tooltip>
        </DescriptionWrapper>
      )}
    </Wrapper>
  );
};

export default Badge;
